import { render, staticRenderFns } from "./imcNinas0a2A.vue?vue&type=template&id=3a77b45c&scoped=true"
import script from "./imcNinas0a2A.vue?vue&type=script&lang=js"
export * from "./imcNinas0a2A.vue?vue&type=script&lang=js"
import style0 from "./imcNinas0a2A.vue?vue&type=style&index=0&id=3a77b45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a77b45c",
  null
  
)

export default component.exports